module.exports = __webpack_public_path__ + "assets/icons/logo-auction-white-95eb.svg";